module.exports = __webpack_public_path__ + "img/智慧公安.d7a5505d.png";